module.exports = __webpack_public_path__ + "media/images/yasu-fd7eada4985e674c143d3a6ad4a346e4.jpg";